export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'prod';

export const NEUROLYTICS_API =
    process.env.REACT_APP_NEUROLYTICS_API || 'https://api.neurolytics.ai';

export const SEARCH_SERVICE_ENDPOINT =
    process.env.REACT_APP_SEARCH_SERVICE_ENDPOINT ||
    'https://search.neurolytics.ai';

export const AUTH0_DOMAIN =
    process.env.REACT_APP_AUTH0_DOMAIN || 'auth.neurolytics.ai';

export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;

export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

export const AUTH0_COMPANY_ADMIN_ROLE_ID =
    process.env.REACT_APP_AUTH0_COMPANY_ADMIN_ROLE_ID;

export const AUTH0_RECRUITER_USER_ROLE_ID =
    process.env.REACT_APP_AUTH0_RECRUITER_USER_ROLE_ID;

export const DASHBOARD_URL =
    process.env.REACT_APP_DASHBOARD_URL || 'https://dashboard.neurolytics.ai';
